import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild
} from "@angular/core";
import {
    IAnalysisAdjustMultiSecsDTO,
    IAnalysisPackage,
    ISecurityDropDown,
    ISecurityDropDownItem
} from "@irb/irb-editors/rebalance/irb-rebalance.model";
import {RebalanceService} from "@irb/irb-editors/rebalance/rebalance.service";
import {UtilityService} from "@irb/irb-common/services/utility.service";
import {AppService} from "@irb/app.service";
import {IrbAppEvents} from "@irb/app.events";
import {SelectItem} from "primeng/api";
import {DeleteHeaderComponent} from "@irb/irb-common/components/grid/renderers/delete.header.component";
import {DeleteCellComponent} from "@irb/irb-common/components/grid/renderers/delete.cell.component";
import {NumericEditorComponent} from "@irb/irb-common/components/grid/editors/numeric-editor.component";
import {CalltoactionService} from "@irb/irb-common/components/calltoaction/calltoaction.service";
import {IrbModelsEvents} from "@irb/irb-models/irb-models.events";
import {OptionToCloseRollCellRenderer} from "@irb/irb-editors/editor-coveredcall-rebalance/coveredcall-rebal-settings/roll-coveredcall-settings/option-to-close-cell/option-to-close-roll-cell-renderer.component";
import {OptionToOpenCellRenderer} from "@irb/irb-editors/editor-coveredcall-rebalance/coveredcall-rebal-settings/roll-coveredcall-settings/option-to-open-cell-renderer.compoent";
import {DecimalPipe} from "@angular/common";
import {IDropdownItem} from "@irb-common/models/dropdown.model";
import {IrbEditorsService} from "@irb/irb-editors/irb-editors.service";
import {IEvent, IrbEditorsEvents} from "@irb-common/events";
import {EditorBuyMultipleReplacementComponent} from "@irb/irb-editors/editor-buy-multiple-replacement/editor-buy-multiple-replacement.component";
import {DialogComponent} from "@irb-common/components/dialog/dialog.component";
import {Subscription} from "rxjs";
import {DropdownFilterComponent} from "@irb/irb-common/components/dropdown-filter/dropdown-filter.component";
import {DropdownFilterRendererComponent} from "@irb/irb-common/components/grid/renderers/dropdown-filter.cell.component";
import {NumberTextBoxComponent} from "@irb/irb-common/components/number-text-box/number-text-box.component";
import {NumberTextBoxEditorComponent} from "@irb/irb-common/components/grid/editors/number-text-box-editor.component";
import {NumberTextBoxRendererComponent} from "@irb-common/components/grid/renderers/number-text-box.cell.component";

@Component({ standalone: false,
    selector: "irb-adjust-securities-rebal-settings",
    templateUrl: "./adjust-securities-rebal-settings.component.html",
    styleUrls: ["./adjust-securities-rebal-settings.component.scss"],
    changeDetection: ChangeDetectionStrategy.Default,
})
export class AdjustSecuritiesRebalSettingsComponent implements OnInit, OnDestroy {
    @ViewChild("IrbadjSecDropdown") selectReference: DropdownFilterComponent;
    @ViewChild("IrbadjTargetSecDropdown") selectTargetReference: DropdownFilterComponent;
    @Output() change = new EventEmitter<any>();
    gridOptions: any;
    grid: any;
    _isReadOnly: boolean;
    securityDropDownRes: ISecurityDropDown = {} as ISecurityDropDown;
    securityDropDown: ISecurityDropDownItem = {} as ISecurityDropDownItem;
    securityDropDownList: ISecurityDropDownItem[];
    adjustMultipleSecurities: IAnalysisAdjustMultiSecsDTO[] = [];
    analysisPackage: IAnalysisPackage;
    toolTipShow: boolean;

    //orderType: string;
    // target: string;
    orderType: IDropdownItem = {value: "BUY_SELL", name: "Either Buys or Sells"};

    target: IDropdownItem = {value: "MODEL_PERC", name: "Model %"};

    percentOfPortfolio: number = 0.0;
    @ViewChild("adjustSecDropDown") adjustSecDropDown: any;
    @ViewChild("dialog") dialog: DialogComponent;
    private eventSubscription: Subscription;
    totalPercent: number = 0.0;
    securitySymbols: any = [];
    selectedSecuritySymbol: string;
    selectedSecToAdd: any;
    securitySymbolsGrid: string[] = [];
    mouseEvent: any;
    numSec: number = 0;
    rowData: any;
    adjustSecTargets: Array<IDropdownItem> = [];
    secuitySymbolMap: Map<string, ISecurityDropDownItem> = new Map();
    secuityIdMap: Map<number, ISecurityDropDownItem> = new Map();
    tooltipMessage: string = "This setting can only be modified in the Global Settings for Trades.";
    isSecFoundInGrid: boolean = false;
    duplicateSecMessage: string = "";
    orderTypes: Array<IDropdownItem> = [
        {value: "BUY", name: "Buys Only"},
        {value: "SELL", name: "Sells Only"},
        {value: "BUY_SELL", name: "Either Buys or Sells"},
    ];
    targets: Array<IDropdownItem> = [
        {value: "MODEL_PERC", name: "Model %"},
        {value: "SPECIFY_PERC", name: "Specify %"},
        {value: "ADD_PREC", name: "Add %"},
        {value: "REDUCE_PREC", name: "Trim %"},
    ];
    addNewSecurityItem: any = {
        button: 'Add new security',
        type: 'security',
        fromComp: 'AdjustSecuritiesRebalSettingsComponent'
    };
    showAutoFocus: boolean = true;
    loadingSecurities: boolean = false;
    buyUsing: string = "CASH_TARGET";
    //@ViewChild("secFoundTooltip") secFoundTooltip: ElementRef;
    isUiTest = false;
    frameworkComponents: any;

    constructor(private cdr: ChangeDetectorRef, private util: UtilityService, private readonly rebalanceService: RebalanceService, private as: AppService, public decimalPipe: DecimalPipe, private ctas: CalltoactionService, private ies: IrbEditorsService) {
    }

    ngOnInit(): void {
        if (!this.isReadOnly) {
            this.loadSecurities();
            this.securitySymbolsGrid = this.sortArrayList(this.securitySymbolsGrid);
            this.securitySymbolsGrid[this.securitySymbolsGrid.indexOf("$CASH")] = "None (leave in cash)";
        }

        this.gridOptions = {
            columnDefs: this.getColumnDefs(),            
            context: {componentParent: this},
            floatingFilter: false,
            overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No Securities for adjustment</span>",
            rowSelection: "multiple",
            onCellValueChanged: (e: any) => this.cellValueChanged(e),
            isExternalFilterPresent: this.isExternalFilterPresent.bind(this),
            doesExternalFilterPass: this.doesExternalFilterPass.bind(this)
        };
        
        this.frameworkComponents = this.getFrameworkComponents();
        this.numSec = 0;
        //this.orderType = null;
        // this.target = null;
        this.eventSubscription = this.as.getEvents().subscribe((s) => {
            this.processEvent(s);
        });

        if(this.data.adjustSecDto.isCashMax) {
            this.buyUsing = "CASH_MAX";
        } else if(this.data.adjustSecDto.isCashMin) {
            this.buyUsing = "CASH_MIN";
        } else if(this.data.adjustSecDto.isCashTarget) {
            this.buyUsing = "CASH_TARGET";
        }
    }

    isExternalFilterPresent() {
        return true;
    }

    doesExternalFilterPass(node: any) {
        return !node.data.isUIdeleted;
    }

    ngOnDestroy(): void {
        if (this.eventSubscription) {
            this.eventSubscription.unsubscribe();
        }
    }

    getFrameworkComponents() {
        return {
            DeleteHeaderComponent: DeleteHeaderComponent,
            DeleteCellComponent: DeleteCellComponent,
            numericEditorComponent: NumericEditorComponent,
            OptionToCloseRollCellRenderer: OptionToCloseRollCellRenderer,
            OptionToOpenCellRenderer: OptionToOpenCellRenderer,
            DropdownFilterRendererComponent: DropdownFilterRendererComponent,
            "NumberTextBoxComponent ": NumberTextBoxComponent,
            NumberTextBoxEditorComponent: NumberTextBoxEditorComponent,
            "NumberTextBoxRendererComponent": NumberTextBoxRendererComponent
        };
    }

    onGridReady(params: any) {
        this.grid = params;
        if (this.analysisPackage.adjustSecDto.adjustMultipleSecurities != null) {
            this.adjustMultipleSecurities = this.analysisPackage.adjustSecDto.adjustMultipleSecurities;
            this.numSec = this.adjustMultipleSecurities.length;
            this.grid.api.setGridOption('rowData', this.adjustMultipleSecurities);
        } else {
            this.grid.api.showNoRowsOverlay();
        }
    }

    setChainTypeOptions(searchStr: any) {
        this.selectReference.set(DropdownFilterComponent.getFilteredList(searchStr,this.orderTypes));
    }

    setTargetChainTypeOptions(searchStr: any) {
        this.selectTargetReference.set(DropdownFilterComponent.getFilteredList(searchStr,this.targets));
    }

    loadSecurities() {
        this.loadingSecurities = true;
        this.rebalanceService.getSecuritiesDropDown().subscribe((res: ISecurityDropDown) => {
            this.securityDropDownRes = res;
            this.securityDropDownRes.items.forEach((element) => {
                this.securitySymbols.push({name: element.securitySymbol, value: element.securityId});
                this.securitySymbolsGrid.push(element.securitySymbol);

                if (element.securitySymbol === "$CASH") {
                    //this.secuitySymbolMap.set("None (leave in cash)", element);
                } else {
                    this.secuitySymbolMap.set(element.securitySymbol, element);
                }
                this.secuityIdMap.set(element.securityId, element);
            });
            this.securitySymbols.sort((a: any, b: any) => {
                return (a.name < b.name) ? -1: 1;
            });
            this.loadingSecurities = false;
        });
    }

    refreshGrid() {
        this.grid.api.deselectAll();
        this.grid.api.hideOverlay();
        const data = this.adjustMultipleSecurities;
        this.grid.api.setGridOption('rowData', data);
        this.cdr.detectChanges();
    }

    onAllowInModified() {
        this.change.emit(true);
    }

    updateOrderType() {
        //this.change.emit(true);
        this.showAutoFocus = false;
        this.adjustMultipleSecurities.forEach((element) => {
            element.transactionType = this.orderType.value;
        });
        this.refreshGrid();
        this.analysisPackage.adjustSecDto.adjustMultipleSecurities = this.adjustMultipleSecurities;
        this.change.emit(this.analysisPackage);
    }

    updateTargetandPercent() {
        //this.change.emit(true);
        this.showAutoFocus = false;
        this.adjustMultipleSecurities.forEach((element) => {
            if (this.target.value === "MODEL_PERC") {
                element.targetType = this.target.value;
                element.targetPercent = null;
            } else {
                element.targetType = this.target.value;
                element.targetPercent = Number(this.percentOfPortfolio);
            }
        });
        this.refreshGrid();
        this.analysisPackage.adjustSecDto.adjustMultipleSecurities = this.adjustMultipleSecurities;
        this.change.emit(this.analysisPackage);
    }

    // onSecuritySelect() {
    //     this.checkForDuplicates();
    // }

    checkForDuplicates(): boolean {
        this.isSecFoundInGrid = false;
        if (this.analysisPackage.adjustSecDto.adjustMultipleSecurities && this.selectedSecuritySymbol) {
            for (let i = 0; i < this.analysisPackage.adjustSecDto.adjustMultipleSecurities.length; i++) {
                let adjSec = this.analysisPackage.adjustSecDto.adjustMultipleSecurities[i];
                if (adjSec.isUIdeleted === false && adjSec.securitySymb === this.selectedSecuritySymbol && adjSec.securityId === this.secuitySymbolMap.get(this.selectedSecuritySymbol).securityId) {
                    this.isSecFoundInGrid = true;
                    break;
                }
            }
        }
        if (this.isSecFoundInGrid) {
            this.duplicateSecMessage = '"' + this.selectedSecuritySymbol + '"' + " is already a security to adjust. Securities cannot be adjusted twice.";
            //setTimeout(() => this.secFoundTooltip.nativeElement.dispatchEvent(new Event("mouseenter")));
        } else {
            this.duplicateSecMessage = "";
        }
        return this.isSecFoundInGrid;
    }

    isAddSecButtonDisable() {
        if (this.isReadOnly || this.isSecFoundInGrid || this.selectedSecuritySymbol === null || this.selectedSecuritySymbol === undefined) {
            return true;
        }
        return false;
    }

    addSecurities() {
        let dupelems: any = [], showWarning = false;
        this.adjustMultipleSecurities.forEach((existingSec: any) => {
            this.adjustSecTargets.forEach((newsec: any) => {
                if (existingSec.securityId === newsec.value && existingSec.isUIdeleted === false) {
                    dupelems.push(newsec);
                    showWarning = true;
                }
                if (existingSec.securityId === newsec.value && existingSec.isUIdeleted === true) {
                    existingSec.isUIdeleted = false;
                    dupelems.push(newsec);
                }
            });
        });
        if (dupelems.length > 0 && showWarning) {
            this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                severity: "warn",
                summary: "",
                detail: "Security(ies) cannot be listed twice.",
            });
        }
        dupelems.forEach((dup: any) => {
            this.adjustSecTargets = this.adjustSecTargets.filter((x: any) => {
                return x.value !== dup.value;
            });
        });

        //this.change.emit(true);
        this.adjustSecTargets.forEach((x: any) => {
            this.adjustMultipleSecurities.push({
                isNew: true,
                securityId: x.value,
                securitySymb: x.name,
                targetType: "MODEL_PERC",
                targetPercent: null,
                transactionType: "BUY_SELL",
                isUIdeleted: false,
            } as IAnalysisAdjustMultiSecsDTO);
            this.numSec = this.numSec + 1;
            this.selectedSecuritySymbol = "";
        });
        this.showAutoFocus = this.adjustMultipleSecurities.length === 1;
        this.refreshGrid();
        this.selectedSecuritySymbol = null;
        this.analysisPackage.adjustSecDto.adjustMultipleSecurities = this.adjustMultipleSecurities;
        this.change.emit(this.analysisPackage);
        this.adjustSecDropDown?.clear();
    }

    cellValueChanged(params: any) {
        //console.log(params);
        const rowSymbol = params.data.securitySymb;
        const colId = params.column.colId;
        const newVaue = params.newValue;
        if (colId === "replacedSymbol") {
        }
        this.analysisPackage.adjustSecDto.adjustMultipleSecurities = this.adjustMultipleSecurities;
        this.change.emit(this.analysisPackage);
    }

    @Input()
    get isReadOnly() {
        return this._isReadOnly;
    }

    set isReadOnly(isReadOnly: boolean) {
        this._isReadOnly = isReadOnly;
    }

    @Input()
    get data() {
        return this.analysisPackage;
    }

    set data(data: IAnalysisPackage) {
        this.analysisPackage = data;
    }

    deleteAll() {
        for (let i = 0; i < this.adjustMultipleSecurities.length; i++) {
            this.adjustMultipleSecurities[i].isUIdeleted = true;
          }
        this.numSec = 0;
        this.adjustMultipleSecurities = this.adjustMultipleSecurities.filter((s: any) => !(s.isNew && s.isUIdeleted));
        this.refreshGrid();
        this.analysisPackage.adjustSecDto.adjustMultipleSecurities = this.adjustMultipleSecurities;
        this.change.emit(this.analysisPackage);
    }

    delete(cc: any) {
        for (let i = 0; i < this.adjustMultipleSecurities.length; i++) {
            if (this.adjustMultipleSecurities[i].securitySymb === cc.securitySymb) {
                this.adjustMultipleSecurities[i].isUIdeleted = true;
                break;
            }
        }
        this.numSec = this.numSec - 1;
        this.adjustMultipleSecurities = this.adjustMultipleSecurities.filter((s: any) => !(s.isNew && s.isUIdeleted));
        this.refreshGrid();
        this.analysisPackage.adjustSecDto.adjustMultipleSecurities = this.adjustMultipleSecurities;
        this.change.emit(this.analysisPackage);
    }

    cancelDelete() {
        this.ctas.remove();
    }

    getRowCount() {
        return this.adjustMultipleSecurities.length;
    }

    isGridEditable() {
        return this.isReadOnly;
    }

    getColumnDefs() {
        return [
            {
                headerName: "Delete All",
                headerComponent: "DeleteHeaderComponent",
                headerComponentParams: {
                    message: "Remove all Entries?",
                    // note: "Settings (such as maintained cash) will be deleted.",
                    proceed: this.deleteAll.bind(this),
                    cancel: this.cancelDelete.bind(this),
                },
                cellRenderer: "DeleteCellComponent",
                cellRendererParams: {
                    message: "Remove this item?",
                    proceed: this.delete.bind(this),
                    cancel: this.cancelDelete.bind(this),
                },
                resizable: false,
                minWidth: 25,
                maxWidth: 25,
                width: 25,
            },

            {
                headerName: "Symbol",
                field: "securitySymb",
                minWidth: 120,
                flex: 2,
                sort: "asc",
                suppressFiltersToolPanel: true,
                editable: false
            },
            {
                headerName: "Order Type",
                field: "transactionType",
                minWidth: 140,
                flex: 2,
                suppressFiltersToolPanel: true,
                cellClass: "dropdownFilterCell",
                cellRenderer: "DropdownFilterRendererComponent",
                cellRendererParams: (params: any) => {
                    return {
                        defaultValue: this.getDefaultTransactionType(params),
                        values: this.orderTypes,
                        size: 25,
                        hoverPanelWidth: 180,
                        onChange: (params: any, item: IDropdownItem) => {
                            params.data.transactionType = item.value;
                            params.api.redrawRows({rowNodes: [params.node]});
                            this.change.emit(this.analysisPackage);
                        },
                    };
                },
            },
            {
                headerName: "Target",
                field: "targetType",
                minWidth: 170,
                flex: 2,
                suppressFiltersToolPanel: true,
                cellClass: "dropdownFilterCell",
                cellRenderer: "DropdownFilterRendererComponent",
                cellRendererParams: (params: any) => {
                    return {
                        defaultValue: {
                            name: this.optionTargetGetter(params.data.targetType),
                            value: params.data.targetType
                        },
                        values: this.targets,
                        size: 25,
                        hoverPanelWidth: 180,
                        onChange: (params: any, item: IDropdownItem) => {
                            params.data.targetType = item.value;
                            if (params.data.targetType === "MODEL_PERC") {
                                params.data.targetPercent = null;
                            } else {
                                 params.data.targetPercent = (params.data.targetPercent !== null && params.data.targetPercent !== undefined)
                                    ? params.data.targetPercent
                                    : null;

                                setTimeout(() => {
                                    let elem: any = document.querySelectorAll(".ag-row-focus .targetPercentClassForFocus input");
                                    if (elem && elem.length !== 0) {
                                        elem[0].focus();
                                    }
                                }, 100);
                            }
                            params.api.redrawRows({rowNodes: [params.node]});
                            this.change.emit(this.analysisPackage);
                        },
                        onClearSelection: (params: any) => {
                            params.data.targetType = "MODEL_PERC";
                            params.data.targetPercent = null;
                            params.api.redrawRows({rowNodes: [params.node]});
                        }
                    };
                },
            },
            {
                headerName: "% of portfolio",
                field: "targetPercent",
                minWidth: 140,
                flex: 1,
                suppressFiltersToolPanel: true,
                cellClass: "numberTextBoxCell targetPercentClassForFocus",
                cellRenderer: "NumberTextBoxRendererComponent",
                cellRendererParams: (params: any) => {
                    return {
                        min: 0,
                        max: 100,
                        places: 2,
                        isPercentage: true,
                        disabled: !this.isTargetPercentEditable(params),
                        autofocus: this.showAutoFocus,
                        autoSelect: true,
                        autoHeight: true,
                        onChange: (params: any, c: any) => {
                            if (params.data.targetPercent !== c.value) {
                                const parsed = parseFloat(c.value);
                                params.data.targetPercent = !isNaN(parsed) ? parsed : null;
                                params.api.redrawRows({rowNodes: [params.node]});
                            }
                        },
                    };
                },
            },
        ];
    }

    percentPortfolioFormatter(params: any) {
        if (params.data.targetPercent !== null && params.data.targetPercent !== undefined) {
            let val = params.context.componentParent.decimalPipe.transform(params.data.targetPercent, "1.2-2");
            return val + "%";
        }
        return "";
    }

    isTargetPercentEditable(params: any) {
        let isEditable = false;

        if (this.isReadOnly) {
            isEditable = false;
        } else {
            if (params.data.targetType === "MODEL_PERC") {
                isEditable = false;
            } else {
                isEditable = true;
            }
        }

        return isEditable;
    }

    sortArrayList(arrayList: string[]) {
        return arrayList.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
    }

   onCashChange(selectedCashType?: string) {
        if (selectedCashType) {
            this.buyUsing = selectedCashType;
        }
        this.data.adjustSecDto.isCashTarget = this.buyUsing == "CASH_TARGET";
        this.data.adjustSecDto.isCashMin = this.buyUsing == "CASH_MIN";
        this.data.adjustSecDto.isCashMax = this.buyUsing == "CASH_MAX";

        this.change.emit(this.data);
    }

    optionOrderTypeSetter(params: any) {
        if (params.oldValue !== params.newValue) {
            switch (params.newValue) {
                case "Buys Only":
                    params.data.transactionType = "BUY";
                    break;
                case "Sells Only":
                    params.data.transactionType = "SELL";
                    break;
                case "Either Buys or Sells":
                    params.data.transactionType = "BUY_SELL";
                    break;
            }
        }
        return true;
    }

    optionOrderTypeGetter(params: any) {
        let transactionType: string = params.data.transactionType;
        if (params.data.transactionType) {
            switch (params.data.transactionType) {
                case "BUY":
                    transactionType = "Buys Only";
                    break;
                case "SELL":
                    transactionType = "Sells Only";
                    break;
                case "BUY_SELL":
                    transactionType = "Either Buys or Sells";
                    break;
            }
        }
        return transactionType;
    }

    optionTargetSetter(params: any) {
        if (params.oldValue !== params.newValue) {
            switch (params.newValue) {
                case "Model %":
                    params.data.targetType = "MODEL_PERC";
                    break;
                case "Specify %":
                    params.data.targetType = "SPECIFY_PERC";
                    break;
                case "Add %":
                    params.data.targetType = "ADD_PREC";
                    break;
                case "Trim %":
                    params.data.targetType = "REDUCE_PREC";
                    break;
            }
        }
        return true;
    }

    optionTargetGetter(value: any) {
        if (value) {
            switch (value) {
                case "MODEL_PERC":
                    return "Model %";
                case "SPECIFY_PERC":
                    return "Specify %";
                case "ADD_PREC":
                    return "Add %";
                case "REDUCE_PREC":
                    return "Trim %";
                default:
                    return value;
            }
        }
    }

    percentPortfolioSetter(params: any) {
        if (params.targetType !== "MODEL_PERC") {
            params.data.targetPercent = Number(params.newValue);
        }
        return true;
    }

    showAddMultipleSecuritiesDialog() {

        let dataInputForMultipleSelection: any = [];
        this.grid.api.forEachNode(function (node: any) {
            if (!node.data.isUIdeleted)
                dataInputForMultipleSelection.push(node.data);
        });
        const params = {
            type: "rebalance",
            data: dataInputForMultipleSelection,
            noDollarcash: true
        };
        this.as.fireEvent(IrbModelsEvents.SHOW_MASTER_MULTIPLE_SECURITY, params);
    }

    getAdjustSecurities(searchStr: any) {
        if (!searchStr || (searchStr && searchStr.trim() === "")) {
            this.adjustSecDropDown.set([]);
            return;
        }
        let interval = 0;
        let timeInterval = setInterval(() => {
            if (!this.loadingSecurities) {
                clearInterval(timeInterval);
                this.adjustSecDropDown.set(DropdownFilterComponent.getFilteredList(searchStr, this.securitySymbols));
            }
            interval = 1000;
        }, interval);

    }

    onAdjustSecChange(s: any) {
        this.adjustSecTargets = s;
    }

    disableAddAdjustSec() {
        return this.adjustSecTargets !== null && this.adjustSecTargets.length > 0;
    }

    private processEvent(event: IEvent) {
        switch (event.type) {
            case IrbEditorsEvents.SHOW_BUY_MULTIPLE_REPLACEMENT:
                this.showBuyMultipleReplacement(event.data);
                break;
            case IrbEditorsEvents.UPDATE_FROM_BUY_MULTIPLE_REPLACEMENT:
                this.updateWithMultiple(event.data);
                break;
            case IrbModelsEvents.SAVE_MASTER_MULTIPLE_SECURITY:
                if (event.data && event.data.type === "rebalance") {
                    this.updateWithMultipleSecurity(event.data);
                }
                break;
            case IrbModelsEvents.SAVE_CREATE_NEW_SECURITY:
                if (event.data) {
                    if (event.data.type === 'security' && event.data.fromComp === 'AdjustSecuritiesRebalSettingsComponent') {
                        this.resetSecuritySearch(event.data)
                        this.loadSecurities();
                    }
                }
                break;
        }
    }

    showBuyMultipleReplacement(eventData: any) {
        const config = this.dialog.getDefaultConfig();
        config.minHeight = "100px";
        config.height = "auto";
        config.width = "550px";
        config.data = eventData;
        this.dialog.open(EditorBuyMultipleReplacementComponent, config);
    }

    updateWithMultiple(eventData: any) {
        //console.log(eventData);
        // eventData.replacements - array of replace with securities
        const updatedSecId = eventData.data.securityId;
        let rowIndex: number = -1;
        this.grid.api.forEachNode((node: any) => {
            if (node.data.securityId === updatedSecId) {
                rowIndex = node.rowIndex;
                node.data.replacedSymbol = "(multiple)";
                node.data.mutipleSecurityAllocations = eventData.replacements;
                //  not sure if it correct place
            }
        });
        if (rowIndex !== -1) {
            const n = this.grid.api.getDisplayedRowAtIndex(rowIndex);
            this.grid.api.redrawRows({rowNodes: [n]});
        }
    }

    updateWithMultipleSecurity(eventData: any) {
        this.adjustSecTargets = eventData.selectedSecurities;

        if (this.adjustSecTargets && this.adjustSecTargets.length) {
            this.showAutoFocus = this.adjustSecTargets.length === 1;
        }

        let dupelems: any = [];
        this.adjustMultipleSecurities.forEach((existingSec: any) => {
            this.adjustSecTargets.forEach((newsec: any) => {
                if (existingSec.securityId === newsec.securityId && existingSec.isUIdeleted === false) {
                    dupelems.push(newsec);
                }
                if (existingSec.securityId === newsec.securityId && existingSec.isUIdeleted === true) {
                    existingSec.isUIdeleted = false;
                    dupelems.push(newsec);
                }
            });
        });

        dupelems.forEach((dup: any) => {
            this.adjustSecTargets = this.adjustSecTargets.filter((x: any) => {
                return x.securityId !== dup.securityId;
            });
        });

        this.adjustSecTargets.forEach((x: any) => {
            this.adjustMultipleSecurities.push({
                securityId: x.securityId,
                securitySymb: x.securitySymbol,
                targetType: this.target.value,
                targetPercent: null,
                transactionType: "BUY_SELL",
                isUIdeleted: false,
                isNew: true
            } as IAnalysisAdjustMultiSecsDTO);
            this.numSec = this.numSec + 1;
            this.selectedSecuritySymbol = "";
        });
        this.refreshGrid();
        this.analysisPackage.adjustSecDto.adjustMultipleSecurities = this.adjustMultipleSecurities;
        this.change.emit(this.analysisPackage);
        this.adjustSecDropDown.clear();
    }

    addSecurity() {
        this.toolTipShow = false;
        if (this.selectedSecToAdd && !this.checkForDuplicates()) {
            if (this.data.adjustSecDto.adjustMultipleSecurities) {
                this.data.adjustSecDto.adjustMultipleSecurities.push(this.selectedSecToAdd);
            } else {
                this.data.adjustSecDto.adjustMultipleSecurities = [];
                this.data.adjustSecDto.adjustMultipleSecurities[0] = this.selectedSecToAdd;
            }
            this.refreshGrid();
            this.change.emit(this.data);
        } else {
            this.toolTipShow = true;
            this.tooltipMessage = "Please select a different security";
        }
    }

    getDefaultTransactionType(params: any) {
        if (params && params.data && params.data.transactionType) {
            let ordTypeVal: string = params.data.transactionType;
            if (params.data.transactionType.toUpperCase() === "SELLS ONLY") {
                ordTypeVal = "SELL"
            }
            if (params.data.transactionType.toUpperCase() === "BUYS ONLY") {
                ordTypeVal = "BUY"
            }
            let selectedOrderType = this.orderTypes.find((x: any) => x.value === ordTypeVal);
            if (selectedOrderType) {
                return selectedOrderType;
            } else {
                return {value: "BUY_SELL", name: "Either Buys or Sells"};
            }
        } else {
            return {value: "BUY_SELL", name: "Either Buys or Sells"};
        }
    }

    openNewItemSecurityFlow(dataParam: any) {
        dataParam = Object.assign({}, this.addNewSecurityItem, dataParam);
        this.as.fireEvent(IrbModelsEvents.SHOW_CREATE_SECURITIES, dataParam);
    }

    resetSecuritySearch(dataParam: any) {
        if (dataParam && dataParam.newItemsForDD && dataParam.newItemsForDD.length !== 0) {
            this.adjustSecDropDown.setValue(dataParam.newItemsForDD);
        }
    }
}
